import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b153bed"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Log ind", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary",
  type: "submit"
}, "Log ind", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card login", { error: _ctx.errorMessage }])
  }, [
    _hoisted_1,
    _createElementVNode("form", {
      class: "form-group",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logIn && _ctx.logIn(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
        type: "text",
        placeholder: "Brugernavn",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.username]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        type: "password",
        placeholder: "Kodeord",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.password]
      ]),
      _hoisted_2,
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.errorMessage !== '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.texts.Login.Hint), 1))
        : _createCommentVNode("", true)
    ], 32)
  ], 2))
}